import { lastPathSegment } from "@/lib/utils";
import { Handle, type Node, type NodeProps, Position } from "@xyflow/react";
import React, { useContext } from "react";
import { idSort } from "../../pages/internal-debugger/InternalDebuggerPage";
import { NodeGraphSolveContext } from "./InternalDebuggerNodeGraph";
import { SelectedNodeContext } from "./InternalDebuggerNodeInfoPanel";
import InternalDebuggerStateValueView from "./InternalDebuggerStateValueView";
import "./InternalDebuggerRuleNode.scss";
import type { GraphNode } from "@imminently/decisively-core";

const InternalDebuggerRuleNode = (props: NodeProps<Node<GraphNode>>) => {
  const { data } = props;
  const solve = useContext(NodeGraphSolveContext);
  const { selected, setSelected } = useContext(SelectedNodeContext);

  const nodeState = solve?.graph?.nodes.filter(
    (node: any) => lastPathSegment(node.v) === data.id && !node.value.hidden,
  );

  const handleClick = () => {
    setSelected(data.id);
  };

  return (
    <div
      tabIndex={0}
      onClick={handleClick}
      className={`RuleNode ${selected === data.id ? "--selected" : ""}`}
    >
      {data.id === solve?.goal && <b>Goal</b>}
      {data.inferred && <b>Inferred</b>}
      <div>{data.description}</div>
      <small>{data.id?.slice(0, 8)}</small>
      <br />
      <Handle
        type="target"
        position={Position.Top}
        style={{ borderRadius: 0 }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="a"
        style={{ borderRadius: 0 }}
      />
      <div className="RuleNode__state">
        {nodeState ? nodeState.sort(idSort).map((node) => <InternalDebuggerStateValueView state={node} />) : null}
      </div>
    </div>
  );
};

export default InternalDebuggerRuleNode;
